export const EDUCATIONS = [
  {
    id: 0,
    title: '가천대학교 컴퓨터공학과',
    date: '2021.03 ~ 2025.02',
    grade: '4.40',
  },
];
